'use client';
import { useGSAP } from '@gsap/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import initAnimation from '../animations/advantage-animation';
import AdvantageItem from './advantage-item';
import { AdvantageItemProps } from './advantage-type-defs';
import { AdvantageIcons } from './advantage-icon-svgs';
import { JContainer } from '@/app/components/ui/layout';

function Advantage() {
    const { t } = useTranslation('advantage');

    const advantagesItems: AdvantageItemProps[] = t('items', {
        returnObjects: true,
    }) as AdvantageItemProps[];

    const rootRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useGSAP(
        () => {
            initAnimation(rootRef.current!, containerRef.current!);
        },
        { scope: rootRef },
    );

    return (
        <section
            ref={rootRef}
            className="flex h-auto w-full items-center justify-center bg-black sm:h-[var(--simulaix-vh,100svh)]"
        >
            <JContainer
                size="lg"
                padding="none"
                ref={containerRef}
                className="grid w-full grid-cols-1 gap-[20px] px-[12px] py-[60px] sm:grid-cols-3 sm:gap-[40px] sm:px-[40px] sm:py-[120px]"
            >
                {advantagesItems.map((item, index) => {
                    const itemKey = `advantage-item-${index}`;
                    const icon = AdvantageIcons[index];
                    return (
                        <div
                            className="advantage-item"
                            id={item.id}
                            key={itemKey}
                        >
                            <AdvantageItem
                                key={itemKey}
                                icon={icon}
                                props={item}
                            />
                        </div>
                    );
                })}
            </JContainer>
        </section>
    );
}

export default Advantage;
